/**
 * FeaturedArtist Component
 */

import { getResponsiveAssets } from '../../../../utils/image';
import { linkWithCurrentQueryString } from '../../../../utils/router';
import { getArtistPagePath, getDefaultTrackAsset } from '../../../../utils/track';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import ImageLoaded from '../../../../containers/ImageLoaded';
import Heading from '../../../atoms/text/Heading';
import { Paragraph } from '../../../atoms/text/Label';
import ThumbnailWithPlayButton from '../../../molecules/buttons/ThumbnailWithPlayButton';

interface IOwnProps {
  track: GQL.ITrackSearchResult;
}

interface IOwnState {
  imageLoaded: boolean;
}

const classes = new BEM('featured-artist');
const defaultList = [];

export default class FeaturedArtist extends React.PureComponent<IOwnProps, IOwnState> {
  render() {

    const {
      track,
    } = this.props;

    return (
      <ImageLoaded>
        {({ imageLoaded }) => (
          <div {...classes('', { loading: !imageLoaded, ready: imageLoaded }) }>
            <ThumbnailWithPlayButton
              displayButtonOnHover
              hyperLinkProps={{
                href: linkWithCurrentQueryString(getArtistPagePath(track)),
              }}
              ratio="four-thirds"
              responsiveAssets={getResponsiveAssets('cover', track.artist!.assets || defaultList)}
              responsive
              size="xxlarge"
              trackId={getDefaultTrackAsset(track.assets!).id}
              {...classes('thumbnail') }
            />
            <div {...classes('content-wrapper') }>
              <Heading
                is="h3"
                hyperLinkProps={{
                  href: getArtistPagePath(track),
                }}
                maxTextLength={32}
                text={track.artist!.name!}
                {...classes('title') }
              />
              <Paragraph {...classes('bio') } text={track.artist!.bio || ''} maxTextLength={280} size="small" />
            </div>
          </div>
        )}
      </ImageLoaded>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/FeaturedArtists/FeaturedArtist.tsx